const Footer = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        // background: "#f1c40f",
        padding: ".5rem",
        borderRadius: ".5rem",
        margin: ".5rem 0",
        color: "#f1c40f",
      }}
    >
      Autogenerated POS by
      <span style={{ color: "#2c3e50", marginLeft: "10px" }}> Pinoy iMD</span>
    </div>
  );
};

export default Footer;
